import types from '../../types';

const security = (state = null, { type, payload }) => {
  switch (type) {
    case types.GET_SECRET_KEY_SUCCESS:
      return payload;
    case types.GET_BOT_URL_SUCCESS:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default security;
